import type { SVGProps } from "react";
const SvgCircleArrowLeft01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M11.25 13.333 8.938 10.25a.42.42 0 0 1 0-.5l2.312-3.083"
    />
    <circle
      cx={10}
      cy={10}
      r={8.333}
      stroke="currentColor"
      strokeWidth={1.25}
    />
  </svg>
);
export default SvgCircleArrowLeft01Sharp;
